<script>
import {
    eventGroupState,
    isSelectedEventGroupLocked
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    commitHistory
} from '@app/store/historyStore.svelte.js';
import {
    editorState
} from "@app/store/editorStore.svelte.js";
import insertEv from '@cclib/functions/eventGroups/insertEvent.js';
import { current } from 'immer';
import { toast } from "@zerodevx/svelte-toast";
import * as m from '@app/paraglide/messages.js';

let isDisabled = $derived(!eventGroupState[projectState.selected] || isSelectedEventGroupLocked());

function insertEvent() {
    try {
        if (!eventGroupState[projectState.selected]){
            return;
        }

        if (isSelectedEventGroupLocked()) {
            toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
            return;
        }
        
        let eventOptions;
        let eventIndex = eventGroupState[projectState.selected].selected.length > 0 ? eventGroupState[projectState.selected].selected[0] + 1 : null;
        const egIdx = projectState.selected;
        
        if (eventGroupState[egIdx].events.length > 0){
            try {
                let eventTemplate = eventGroupState[egIdx].selected.length > 0 ? eventGroupState[egIdx].events[eventGroupState[egIdx].selected[0]] : eventGroupState[egIdx].events[eventGroupState[egIdx].events.length-1];

                eventOptions = {
                    ...eventOptions,
                    alignment : eventTemplate.alignment, 
                    xPos : eventTemplate.xPos,
                    yPos : eventTemplate.yPos,
                    vertical : eventTemplate.vertical,
                    voice : eventTemplate.voice,
                    speakingStyle : eventTemplate.speakingStyle,
                    style : eventTemplate.style,
                    rate : eventTemplate.rate,
                    track : eventTemplate.track ?? false,
                    start: editorState.insertStartOnInsert ? player.currentTime : false,
                    end: editorState.insertStartOnInsert ? player.currentTime + eventGroupState[egIdx].minDuration : false,
                }     
            } catch(err){
                console.log(err);
            }
        }

        commitHistory({
            name: "insert event",
            eventGroup: egIdx,
            mutate: {
                eventGroupState: (draft) => {
                    draft[egIdx] = insertEv(
                        current(draft[egIdx]),
                        eventOptions,
                        eventIndex,
                    );
                    draft[egIdx].selected =
                        eventIndex !== null
                            ? [eventIndex]
                            : [draft[egIdx].events.length - 1];
                },
            },
        });

        editorState.editing = true;
        window.focus();

        const selectedIndex = eventGroupState[egIdx].selected[0];
        
        // Dispatch custom event to scroll to the newly added event
        window.dispatchEvent(new CustomEvent('scrollToVirtualListItem', {
            detail: { index: selectedIndex }
        }));
    } catch(err){
        console.log(err, err.message);
    }
}
</script>
<li class="nav-item" title={m.add_event_title()}>
    <a
        class="nav-link" 
        href="#!/" 
        id="add-event-btn"
        role="button"
        aria-label={m.add_event_aria_label()}
        class:disabled={isDisabled}
        aria-disabled={isDisabled}
        onclick={insertEvent}
    ><i class="bi bi-plus-circle"></i></a>
</li>
